import React from "react"
import { call, put, takeLeading, select } from "redux-saga/effects"
import * as Api from "./services"
import { toastr } from "react-redux-toastr"
import { addLCS, removeLCS, rebuildBase64 } from "./generalUtils"
import I18n from "../i18n"

export function* getSmsQuota(action) {
	try {
		//console.log(action)
		yield put({ type: "actions/setLAR" })
		addLCS(action)

		let xLsT = yield select((state) => state.auth.xLsToken)
		let token = yield select((state) => state.auth.token.token)
		let payload = { token, xLsT }

		const data = yield call(Api.getSmsQuota, payload)

		switch (data) {
			case "sessionExpired":
				return yield put({ type: "auth/showPadlock" })
			case "sessionDestroyed":
				return yield put({ type: "auth/sessionExpired" })
			case true:
				return removeLCS(action)
			default: {
				removeLCS(action)
				//console.log(data)
				return yield put({
					type: "action/setLAR",
					payload: { message: "quotaRetrieved", data },
				})
			}
		}
	} catch (error) {
		//console.log(error)
	}
}

export function* getMeta(action) {
	try {
		//console.log(action)
		yield put({ type: "actions/setLAR" })
		addLCS(action)

		let xLsT = yield select((state) => state.auth.xLsToken)
		let token = yield select((state) => state.auth.token.token)
		let payload = { token, xLsT }

		const data = yield call(Api.getMeta, payload)
		switch (data) {
			case "sessionExpired":
				return yield put({ type: "auth/showPadlock" })
			case "sessionDestroyed":
				return yield put({ type: "auth/sessionExpired" })
			case true:
				return removeLCS(action)
			default: {
				removeLCS(action)
				//console.log(data)
				return yield put({
					type: "action/setLAR",
					payload: { message: "getMeta", data },
				})
			}
		}
	} catch (error) {
		//console.log(error)
	}
}

export function* getSsoCheck(action) {
	try {
		yield put({ type: "actions/setLAR" })
		addLCS(action)

		let xLsT = yield select((state) => state.auth.xLsToken)
		let token = yield select((state) => state.auth.token.token)
		let payload = { token, xLsT, ...action.payload }

		yield put({ type: "params/setActionLoading", payload: true })
		const data = yield call(Api.getSsoCheck, payload)
		yield put({ type: "params/setActionLoading" })

		switch (data) {
			case "sessionExpired":
				return yield put({ type: "auth/showPadlock" })
			case "sessionDestroyed":
				return yield put({ type: "auth/sessionExpired" })
			case true:
				removeLCS(action)
				return yield put({
					type: "action/setLAR",
					payload: { message: "ssoCheckError" },
				})
			default: {
				removeLCS(action)
				//console.log(data)
				return yield put({
					type: "action/setLAR",
					payload: { message: "getSsoCheck", data },
				})
			}
		}
	} catch (error) {
		//console.log(error)
		yield put({ type: "params/setActionLoading" })
		return yield put({
			type: "action/ssoCheckError",
		})
	}
}

export function* delSso(action) {
	try {
		//console.log(action, "action");
		addLCS(action)
		yield put({ type: "params/setLAR" })
		yield put({ type: "action/setActionLoader", payload: true })

		let xLsT = yield select((state) => state.auth.xLsToken)
		let token = yield select((state) => state.auth.token.token)

		let payload = { token, xLsT }

		const data = yield call(Api.delSso, payload)
		yield put({ type: "action/setActionLoader" })

		switch (data) {
			case "sessionExpired":
				return yield put({ type: "auth/showPadlock" })
			case "sessionDestroyed":
				return yield put({ type: "auth/sessionExpired" })
			case true:
				return removeLCS(action)
			default: {
				removeLCS(action)

				toastr.success(I18n.t("params.pp.removeSuccess"))
				return yield put({
					type: "params/setLAR",
					payload: { message: "successDelSso" },
				})
			}
		}
	} catch (error) {
		//console.log(error)
	}
}

export function* getSso(action) {
	try {
		addLCS(action)
		yield put({ type: "params/setLAR" })
		yield put({
			type: "action/setActionLoader",
			payload: { transparency: true },
		})

		let xLsT = yield select((state) => state.auth.xLsToken)
		let token = yield select((state) => state.auth.token.token)

		let payload = { token, xLsT, ...action.payload }

		const data = yield call(Api.getSso, payload)
		yield put({ type: "action/setActionLoader" })

		switch (data) {
			case "sessionExpired":
				return yield put({ type: "auth/showPadlock" })
			case "sessionDestroyed":
				return yield put({ type: "auth/sessionExpired" })
			case true:
				return removeLCS(action)
			default: {
				removeLCS(action)

				//toastr.success(I18n.t("params.pp.removeSuccess"))
				return yield put({
					type: "params/setLAR",
					payload: { message: "successGetSso", data },
				})
			}
		}
	} catch (error) {
		//console.log(error)
	}
}

export function* ssoUrl(action) {
	try {
		yield put({ type: "actions/setLAR" })
		addLCS(action)

		let xLsT = yield select((state) => state.auth.xLsToken)

		let payload = {
			xLsT,
			xmlMetadata: action.payload.url,
			onlyGroups: action.payload.groupADBlockConnetion,
		}

		yield put({
			type: "action/setActionLoader",
			payload: {
				transparency: true,
			},
		})
		const data = yield call(Api.ssoUrl, payload)
		yield put({ type: "action/setActionLoader" })

		switch (data) {
			case "sessionExpired":
				return yield put({ type: "auth/showPadlock" })
			case "sessionDestroyed":
				return yield put({ type: "auth/sessionExpired" })
			case true:
				return removeLCS(action)
			default: {
				removeLCS(action)
				//console.log(data)
				toastr.success(I18n.t("params.iSSO.importDone"))
				return yield put({
					type: "action/setLAR",
					payload: { message: "urlPost", data },
				})
			}
		}
	} catch (error) {
		//console.log(error)
	}
}

export function* ssoXml(action) {
	try {
		// console.log(action,"action");
		yield put({ type: "actions/setLAR" })
		addLCS(action)
		let xmlFile

		if (action.payload.url) {
			xmlFile = yield call(Api.getExternalFile, action.payload.url)
		} else {
			xmlFile = action.payload.file
		}

		let xLsT = yield select((state) => state.auth.xLsToken)
		let token = yield select((state) => state.auth.token.token)
		let payload = {
			token,
			xLsT,
			file: xmlFile,
			onlyGroups: action.payload.groupADBlockConnetion,
		}

		yield put({
			type: "action/setActionLoader",
			payload: {
				transparency: true,
			},
		})
		const data = yield call(Api.ssoXml, payload)
		yield put({ type: "action/setActionLoader" })

		switch (data) {
			case "sessionExpired":
				return yield put({ type: "auth/showPadlock" })
			case "sessionDestroyed":
				return yield put({ type: "auth/sessionExpired" })
			case true:
				return removeLCS(action)
			default: {
				removeLCS(action)
				//console.log(data)
				toastr.success(I18n.t("params.iSSO.importDone"))
				return yield put({
					type: "action/setLAR",
					payload: { message: "xmlPost" },
				})
			}
		}
	} catch (error) {
		yield put({ type: "params/setActionLoading" })
		// console.log("error in ssoXml saga", error)
	}
}

export function* getInternalWhitemark(action) {
	try {
		//console.log(action)
		yield put({ type: "actions/setLAR" })
		addLCS(action)

		let xLsT = yield select((state) => state.auth.xLsToken)
		let token = yield select((state) => state.auth.token.token)
		let payload = { token, xLsT }

		const data = yield call(Api.getInternalWhitemark, payload)

		switch (data) {
			case "sessionExpired":
				return yield put({ type: "auth/showPadlock" })
			case "sessionDestroyed":
				return yield put({ type: "auth/sessionExpired" })
			case true:
				return removeLCS(action)
			default: {
				removeLCS(action)

				if (data)
					yield put({
						type: "action/setLAR",
						payload: { message: "whitemark", data },
					})

				return
			}
		}
	} catch (error) {
		//console.log(error)
	}
}

export function* changeColorWm(action) {
	try {
		yield put({ type: "actions/setLAR" })
		addLCS(action)

		let xLsT = yield select((state) => state.auth.xLsToken)
		let token = yield select((state) => state.auth.token.token)
		let auth = yield select((state) => state.auth)
		let organizationId = yield select(
			(state) =>
				state.auth.token.userSession.organizationIds[auth.selectedOrg],
		)
		let whitemarks = yield select(
			(state) => state.auth.token.userSession.userWhitemark,
		)
		let payload = {
			token,
			xLsT,
			data: { ...whitemarks, ...action.payload.data, organizationId },
		}

		const data = yield call(Api.changeColorWm, payload)

		switch (data) {
			case "sessionExpired":
				return yield put({ type: "auth/showPadlock" })
			case "sessionDestroyed":
				return yield put({ type: "auth/sessionExpired" })
			case true: {
				// The error toastr is already displayed by handleError in the service.
				// Since the loader isn't managed by redux store, but directly with the whitemark popup, we need to
				// set the lar to allow the component to stop the loader
				removeLCS(action)

				return yield put({
					type: "action/setLAR",
					payload: { message: "WmPosted" },
				})
			}
			default: {
				if (!data || typeof data !== "object") {
					removeLCS(action)
					return yield put({
						type: "action/setLAR",
						payload: { message: "WmPosted" },
					})
				}

				// Only merge the internal-scope fields actually returned by the
				// backend: echoing the raw response into redux would let empty
				// or "undefined" values overwrite the freshly saved whitemark
				// (JSMLSV3-670).
				const dispatchPayload = { internalWhitemarkChanged: true }
				if (data.colorIntern1 && data.colorIntern1 !== "undefined")
					dispatchPayload.colorIntern1 = data.colorIntern1
				if (data.colorIntern2 && data.colorIntern2 !== "undefined")
					dispatchPayload.colorIntern2 = data.colorIntern2
				if (data.colorIntern3 && data.colorIntern3 !== "undefined")
					dispatchPayload.colorIntern3 = data.colorIntern3
				if (data.colorIntern4 && data.colorIntern4 !== "undefined")
					dispatchPayload.colorIntern4 = data.colorIntern4
				if (typeof data.isSquareLogo === "boolean")
					dispatchPayload.isSquareLogo = data.isSquareLogo
				// The images send by the backend are in base64 format and have been truncated. Before storing them,
				// put back the beginning of the base64.
				if (data.logoUrl && data.logoUrl !== "undefined")
					dispatchPayload.logoUrl = rebuildBase64(
						data.logoUrl,
						"image",
						"svg+xml",
					)

				removeLCS(action)
				toastr.warning("", "", {
					component: (
						<div
							dangerouslySetInnerHTML={{
								__html: `<b>${I18n.t(
									"params.whitemark.toastr.internalSuccess",
								)}</b>`,
							}}
						/>
					),
				})
				// updateWm merges the payload into redux and synchronizes localStorage,
				// keeping both stores consistent for the next popup opening.
				yield put({
					type: "auth/updateWm",
					payload: dispatchPayload,
				})

				// success lets the popup distinguish a real save from the
				// error paths (which emit the same message to stop the loader).
				return yield put({
					type: "action/setLAR",
					payload: { message: "WmPosted", success: true },
				})
			}
		}
	} catch (error) {
		// Whatever the failure, unlock the popup loader.
		yield put({
			type: "action/setLAR",
			payload: { message: "WmPosted" },
		})
	}
}

export function* changeColorWmExternal(action) {
	try {
		yield put({ type: "actions/setLAR" })
		addLCS(action)

		let xLsT = yield select((state) => state.auth.xLsToken)
		let token = yield select((state) => state.auth.token.token)
		let auth = yield select((state) => state.auth)
		let organizationId = yield select(
			(state) =>
				state.auth.token.userSession.organizationIds[auth.selectedOrg],
		)
		let whitemarks = yield select(
			(state) => state.auth.token.userSession.userWhitemark,
		)
		let payload = {
			token,
			xLsT,
			data: { ...whitemarks, ...action.payload.data, organizationId },
		}

		const data = yield call(Api.changeColorWmExternal, payload)

		switch (data) {
			case "sessionExpired":
				return yield put({ type: "auth/showPadlock" })
			case "sessionDestroyed":
				return yield put({ type: "auth/sessionExpired" })
			case true: {
				// The error toastr is already displayed by handleError in the service.
				// Since the loader isn't managed by redux store, but directly with the whitemark popup, we need to
				// set the lar to allow the component to stop the loader
				removeLCS(action)

				return yield put({
					type: "action/setLAR",
					payload: { message: "ExternalWmPosted" },
				})
			}
			default: {
				if (!data || typeof data !== "object") {
					removeLCS(action)
					return yield put({
						type: "action/setLAR",
						payload: { message: "ExternalWmPosted" },
					})
				}

				// Only merge the external-scope fields actually returned by the
				// backend: echoing the raw response into redux would let empty
				// or "undefined" values overwrite the freshly saved whitemark
				// (JSMLSV3-670).
				// The images send by the backend are in base64 format and have been truncated. Before storing them,
				// put back the beginning of the base64.
				const dispatchPayload = {}
				if (data.favicon && data.favicon !== "undefined")
					dispatchPayload.favicon = rebuildBase64(
						data.favicon,
						"image",
						"svg+xml",
					)
				if (data.banner && data.banner !== "undefined")
					dispatchPayload.banner = rebuildBase64(
						data.banner,
						"image",
						"png",
					)
				if (data.background && data.background !== "undefined")
					dispatchPayload.background = rebuildBase64(
						data.background,
						"image",
						"png",
					)
				// companyName and emailLanguage may legitimately be cleared by
				// the user: accept "" from the echo, only skip absent fields.
				if (
					typeof data.companyName === "string" &&
					data.companyName !== "undefined"
				)
					dispatchPayload.companyName = data.companyName
				if (typeof data.emailLanguage === "string")
					dispatchPayload.emailLanguage = data.emailLanguage
				if (data.bgColorClickButton !== undefined)
					dispatchPayload.bgColorClickButton =
						data.bgColorClickButton === "undefined"
							? ""
							: data.bgColorClickButton

				removeLCS(action)
				toastr.success(
					I18n.t("params.whitemark.toastr.externalSuccess"),
				)
				// updateWm merges the payload into redux and synchronizes localStorage,
				// keeping both stores consistent for the next popup opening.
				yield put({
					type: "auth/updateWm",
					payload: dispatchPayload,
				})
				// success lets the popup distinguish a real save from the
				// error paths (which emit the same message to stop the loader).
				return yield put({
					type: "action/setLAR",
					payload: { message: "ExternalWmPosted", success: true },
				})
			}
		}
	} catch (error) {
		// Whatever the failure, unlock the popup loader.
		yield put({
			type: "action/setLAR",
			payload: { message: "ExternalWmPosted" },
		})
	}
}

export function* updateUserConnexionNumber(action) {
	try {
		let xLsT = yield select((state) => state.auth.xLsToken)
		let token = yield select((state) => state.auth.token.token)
		let payload = { token, xLsT, connexionNumber: action.payload }

		yield put({
			type: "auth/updateUserConnexionNumber",
			payload: action.payload,
		})
		return yield call(Api.patchConnexion, payload)
	} catch (error) {
		/*console.log(error)*/
	}
}

export default function* generalSagas() {
	yield takeLeading("G_GET_SMS_QUOTA_SAGA", getSmsQuota)
	yield takeLeading("G_GET_INTERNAL_WHITEMARK_SAGA", getInternalWhitemark)
	yield takeLeading("G_CHANGE_COLOR_WHITEMARK_SAGA", changeColorWm)
	yield takeLeading(
		"G_CHANGE_COLOR_WHITEMARK_EXTERNAL_SAGA",
		changeColorWmExternal,
	)
	yield takeLeading("G_GET_SSO_SAGA", getSso)
	yield takeLeading("G_DELETE_SSO_SAGA", delSso)
	yield takeLeading("G_POST_SSO_URL_SAGA", ssoUrl)
	yield takeLeading("G_POST_SSO_XML_SAGA", ssoXml)
	yield takeLeading(
		"G_UPDATE_USER_CONNEXION_NUMBER_SAGA",
		updateUserConnexionNumber,
	)
	yield takeLeading("G_GET_META_SAGA", getMeta)
	yield takeLeading("G_GET_SSO_CHECK_SAGA", getSsoCheck)
}
